import { render, staticRenderFns } from "./SendMail.vue?vue&type=template&id=7204f8a7&"
import script from "./SendMail.vue?vue&type=script&lang=js&"
export * from "./SendMail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports